/**
 * Google Ads 转化跟踪方法
 * @param {string} gtagId - 转化ID (如 'AW-123456789/AbCdEfGhIjKl')
 * @param {number} value - 转化价值 (可选)
 * @param {string} currency - 货币代码 (默认 'USD')
 * @param {string} url - 转化后跳转的URL (可选)
 */
export const trackAdsConversion = (gtagId, value = 1, currency = 'USD', url) => {
    if (!window.gtag) {
      console.warn('gtag is not available');
      return;
    }
  
    const callback = url ? () => { window.location = url; } : undefined;
  
    window.gtag('event', 'conversion', {
      'send_to': gtagId,
      'value': value,
      'currency': currency,
      'event_callback': callback
    });
  };